export const decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions";
